var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-messages pr-2" },
    [
      _vm.fieldData.error &&
      _vm.fieldData.error !== "Required." &&
      _vm.fieldData.has_error
        ? [
            _c("div", { staticClass: "form-row mx-0" }, [
              _c("div", { staticClass: "text-danger px-2 mt-1 aaa" }, [
                _vm._v("\n        " + _vm._s(_vm.fieldData.error) + "\n      ")
              ])
            ])
          ]
        : _vm.errors.has(_vm.fieldData.field_name) &&
          _vm.errors.first(_vm.fieldData.field_name) !== "Required."
        ? [
            _c("div", { staticClass: "form-row mx-0" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has(_vm.fieldData.field_name),
                      expression: "errors.has(fieldData.field_name)"
                    }
                  ],
                  staticClass: "text-danger px-2 mt-1 bbb"
                },
                [
                  _c("i", {
                    staticClass: "fas fa-exclamation-triangle",
                    attrs: { title: "Required field icon" }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.errors.first(_vm.fieldData.field_name)) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        : _vm.errors.has(_vm.fieldData.field_name) ||
          (_vm.fieldData.has_error &&
            (_vm.errors.first(_vm.fieldData.field_name) === "Required." ||
              _vm.fieldData.error === "Required."))
        ? [_vm._m(0)]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row mx-0 required-error-block" }, [
      _c("div", { staticClass: "text-danger px-2 mt-1 required-error ccc" }, [
        _c("i", {
          staticClass: "fas fa-exclamation-triangle",
          attrs: { title: "Required Field" }
        }),
        _vm._v("\n        Required.\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a23a3bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a23a3bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/FieldMessages.vue
// module id = null
// module chunks = 